import type { FC, ReactElement } from 'react';
import { useEffect, useState, lazy } from 'react';

import { useFeature } from '../../services/features/reactBindings/hooks';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { HeaderModal } from '../../store/slices/header/types';
import { Modal } from '../modal/modal/Modal';
import { Suspended } from '../suspended/Suspended';

const LazyHistoryContainerConnected = lazy(() => import('./container/HistoryContainerConnected'));

export const HistoryModalConnected: FC = (): ReactElement => {
  const newLayout = useFeature('newLayout');
  const dispatch = useCoreDispatch();

  const heightAdjustment = useConfigSlice.playAreaDimensions()?.height;
  const openedModal = useHeaderSlice.getCoreOpenedModal();

  const [isGameHistoryShown, setIsGameHistoryShown] = useState<boolean>(false);

  useEffect(() => {
    if (openedModal === HeaderModal.History) {
      setIsGameHistoryShown(false);
    }
  }, [openedModal]);

  const onClose = (): void => {
    dispatch(headerActions.setOpenedModal(null));
  };

  const onBack = (): void => {
    setIsGameHistoryShown(false);
  };

  const handleSetIsGameHistory = (value: boolean): void => {
    setIsGameHistoryShown(value);
  };

  return (
    <Modal
      data-testid="history-modal"
      draggable
      fullScreenNoClose
      grow
      heightAdjustment={heightAdjustment}
      isHistoryModal
      onBack={isGameHistoryShown ? onBack : undefined}
      onClose={onClose}
      open={openedModal === HeaderModal.History}
      originX="end"
      newLayout={newLayout}
      tk="HISTORY"
    >
      <Suspended>
        <LazyHistoryContainerConnected
          handleGameHistoryShown={handleSetIsGameHistory}
          isGameHistoryShown={isGameHistoryShown}
        />
      </Suspended>
    </Modal>
  );
};
